import React from 'react';
import './Fpv.css';
import FpvRtc from './FpvRtc';

// Вариант 1: если точный тип drone неизвестен
type FpvProps = {
  drone: Drone; // временно, потом заменишь на свой интерфейс Drone
};

// Вариант 2 (более строгий, если drone может быть null)
// type FpvProps = {
//   drone: Drone | null;
// };

const Fpv: React.FC<FpvProps> = ({ drone }) => {
  return (
    <div className="fpv">
      <FpvRtc drone={drone} />
    </div>
  );
};

export default Fpv;